export enum CoinType {
  Fiat = 'fiat',
  Crypto = 'crypto',
  Demo = 'demo',
}
